module.exports = __webpack_public_path__ + "img/pengangkutan-barang.c3f04faa.webp";